import UltMeta, { Meta } from "./UltMeta/index";

class VehiclePlateColor extends UltMeta {
    BLUE = new Meta(1, "蓝色");
    YELLOW = new Meta(2, "黄色");
    YELLOW_GREEN = new Meta(3, "黄绿色");
}
export const VEHICLE_PLATE_COLOR = new VehiclePlateColor();
